<template>
  <page-template type="rightpanel">
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div class="action-section">
          <tool-bar type="only-title" title="gestion des actions"></tool-bar>
          <div>
            <div class="d-flex justify-space-between">
              <h2>Gestion locataire</h2>
              <v-icon>mdi-chevron-down</v-icon>
            </div>
            <rectangular-banner type="home" title="demande de locataire" textbutton="Voir le dossier"></rectangular-banner>
          </div>
          <div>
            <div class="d-flex justify-space-between">
              <h2>Annonces</h2>
              <v-icon>mdi-chevron-down</v-icon>
            </div>
            <rectangular-banner type="home" title="annonce à valider" textbutton="Voir l'annonce"></rectangular-banner>
            <rectangular-banner type="home" title="annonce à valider" textbutton="Voir l'annonce"></rectangular-banner>
            <rectangular-banner type="home" title="annonce à valider" textbutton="Voir l'annonce"></rectangular-banner>
            <div class="d-flex see-more">
            <v-btn to="/annonces" class="primary-button outlined">Voir tout</v-btn>
            </div>
          </div>
          <div>
            <div class="d-flex justify-space-between">
              <h2>Parrainage</h2>
              <v-icon>mdi-chevron-down</v-icon>
            </div>
            <rectangular-banner type="home" title="soumission de locataire" textbutton="Voir la candidature"></rectangular-banner>
          </div>
        </div>
        <div class="summary-section">
          <h2>Incidents et interventions</h2>
          <div class="d-flex mb-12 summary-content">
            <div class="mr-8 text-center summary-item submitted">
              <p class="mb-4 figure">0</p>
              <p class="mb-12 status">Soumises</p>
              <a href="" class="text-uppercase">Traiter</a>
            </div>
            <div class="mr-8 text-center summary-item ongoing">
              <p class="mb-4 figure">0</p>
              <p class="mb-12 status">En cours</p>
              <a href="" class="text-uppercase">Voir</a>
            </div>
            <div class="mr-8 text-center summary-item finalized">
              <p class="mb-4 figure">0</p>
              <p class="mb-12 status">Terminées</p>
              <a href="" class="text-uppercase">Evaluations</a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <div class="fill-height">
        <div class="to-validate-section">
          <div v-if="operation" class="d-flex flex-column">
            <h2>Opérations à publier</h2>
            <rectangular-element
              :key="operation._id"
              :title="operation.title"
              :date="operation.dateStart"
              :guide="getCatById(operation.category)"
              :actions="opeitems"
              :id="operation._id"
              :publish-url="`${apiURL}/manage/operation/activated/${operation._id}`"
              :publish-object="operation"
              @update="updateOperations()"
              class="to-publish"
            ></rectangular-element>
          </div>
          <div v-if="poll" class="d-flex flex-column">
            <h2>Enquêtes à publier</h2>
            <rectangular-element
              :key="poll._id"
              :title="poll.title"
              :date="poll.dateStart"
              :actions="pollitems"
              :id="poll._id"
              linkresult="enquetes/resultat"
              @update="updatePolls()"
              class="to-publish"
            ></rectangular-element>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<style lang="scss">
  .central-panel >:first-child{
    .action-section{
      .v-icon.mdi-chevron-down{
        display: none;
        @include phone{
          display: flex;
        }
      }
      .see-more{
        justify-content: flex-end;
        @include phone{
          justify-content: center;
        }
      }
    }
    .summary-section{
      .summary-content{
        @include phone{
          flex-direction: column;
        }
        .summary-item{
          width: 10vw;
          padding: 2rem 1rem;
          line-height: 1;
          color: white;
          border-radius: 10px;
          box-shadow: 0px 4px 8px 0px rgba(79, 55, 84, 0.4);
          @include phone{
            width: 100%;
            margin: 1rem 0;
          }
          .figure{
            font-size: 3rem;
            @include bigScreen{
              font-size: 4rem;
            }
          }
          .status{
            font-size: 1rem;
            font-weight: 600 !important;
            @include bigScreen{
              font-size: 1.4rem;
            }
          }
          a{
            color: white;
            font-size: 0.7rem;
            @include bigScreen{
              font-size: 0.9rem;
            }
          }
          &.submitted{
            background: #83A3CE;
          }
          &.ongoing{
            background: #D48EAE;
          }
          &.finalized{
            background: #AC7AB6;
          }
        }
      }
      }
  }
  .right-panel >:first-child{
    .account{
      p{
        font-family: 'proxima-nova';
        font-weight: bold;
        font-size: 0.7rem;
        @include bigScreen{
          font-size: 1.2rem;
        }
      }
      img{
        width: 2.5rem;
        @include bigScreen{
          width: 4rem;
        }
      }
    }
  }
</style>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularBanner from '@/components/RectangularBanner.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'

  export default {
    name: 'Home',
    components: { pageTemplate, toolBar, rectangularBanner, rectangularElement },
    data: () => {
      return {
        status: false,
        operation: [],
        operationCategories: [],
        poll: [],
        apiURL
      }
    },
    async created () {
      try {
        this.$store.dispatch('loading')
        // GET LAST UNPUBLISHED OPERATION
        const lastUnpublishedOperationRes = await axios.get(`${apiURL}/data/operations/last`)
        this.operation = lastUnpublishedOperationRes.data.model
        // OPERATION CATEGORIES
        const operationCategoriesRes = await axios.get(`${apiURL}/data/operation/categories`)
        this.operationCategories = operationCategoriesRes.data.model
        // GET LAST UNPUBLISHED POLL
        const lastUnpublishedPollRes = await axios.get(`${apiURL}/data/operations/last`)
        this.poll = lastUnpublishedPollRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    computed: {
      opeitems () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.opeEditCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.opeOpenCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.opeDuplicateCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.opeDeactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.opeDeleteCb }
        ]
      },
      pollitems () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.pollEditCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.pollOpenCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.pollDuplicateCb },
          { title: 'Réponses', icon: 'mdi-chart-bar', callback: this.pollAnswersCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.pollDeactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.pollDeleteCb }
        ]
      }
    },
    methods: {
      getCatById (id) {
        const cats = this.operationCategories.filter(c => {
          return c._id === id
        })
        return cats.length ? cats[0].name : ''
      }
    },
    async updateOperations () {
      try {
        this.$store.dispatch('loading')
        // LAST UNPUBLISHED OPERATION
        const operationRes = await axios.get(`${apiURL}/data/operations/last`)
        this.operation = operationRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // EDIT OPERATION
    opeEditCb (id) {
      this.$router.push(`/operations/edit/${id}`)
    },
    // OPEN OPERATION
    opeOpenCb (id) {
      this.$router.push(`/operations/open/${id}`)
    },
    // DUPLICATE OPERATION
    async opeDuplicateCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.post(`${apiURL}/manage/operation/duplicate/${id}`)
        await this.updateOperations()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // DEACTIVATE OPERATION
    async opeDeactivateCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.put(`${apiURL}/manage/operation/unactivated/${id}`)
        await this.updateOperations()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // DELETE OPERATION
    async opeDeleteCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.delete(`${apiURL}/manage/operation/${id}`)
        await this.updateOperations()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    async updatePolls () {
      try {
        this.$store.dispatch('loading')
        // LAST UNPUBLISHED POLL
        const pollRes = await axios.get(`${apiURL}/data/operations/last`)
        this.poll = pollRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // EDIT POLL
    pollEditCb (id) {
      this.$router.push(`/enquetes/edit/${id}`)
    },
    // OPEN POLL
    pollOpenCb (id) {
      this.$router.push(`/enquetes/open/${id}`)
    },
    // DUPLICATE POLL
    async pollDuplicateCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.post(`${apiURL}/polls/duplicate/${id}`)
        await this.updatePolls()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // GO TO ANSWERS
    pollAnswersCb (id) {
      this.$router.push(`/enquetes/resultat/${id}`)
    },
    // DEACTIVATE POLL
    async pollDeactivateCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.put(`${apiURL}/polls/${id}/deactivate`)
        await this.updateOperations()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    // DELETE POLL
    async pollDeleteCb (id) {
      try {
        this.$store.dispatch('loading')
        await axios.delete(`${apiURL}/polls/${id}`)
        await this.updateOperations()
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    }
  }
</script>